export const SupplierComplaintStatus = [
	{
		name: "Supplier preparing your order",
		value: "Supplier preparing your order",
	},
	{
		name: "Out for Delivery",
		value: "Out for Delivery",
	},
	{
		name: "Delivered",
		value: "Delivered",
	},
];
